export const TEMPLATES = '/certificates';
export const STORE_TEMPLATES = '/store-templates';
export const PRODUCTS_URL = '/store/products';
export const ORDERS = '/certificates/order';
